import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import React from 'react';
import { spendFormatter } from 'utils/filterNames';
import { formatSpendWithDecimalAndSymbol } from 'utils/number';

export const EXPORT_OPTIONS = [
	{
		label: 'Export as image',
		value: 'png',
	},
];

export const MODULE_KPI_NAME = {
	uniquE_SKU_COUNT: 'SKU Count',
	uniquE_CATEGORY_1_COUNT: 'Category 1 Count',
	uniquE_CATEGORY_2_COUNT: 'Category 2 Count',
	uniquE_CATEGORY_3_COUNT: 'Category 3 Count',
	uniquE_COUNT: 'Row Count',
	skU_COUNT: 'SKU Count',
	categorY_1_COUNT: 'Category 1 Count',
	categorY_2_COUNT: 'Category 2 Count',
	categorY_3_COUNT: 'Category 3 Count',
	totaL_COUNT: 'Row Count',
	createD_AT: 'Created At',
	updateD_AT: 'Updated At',
	supplieR_COUNT: 'Supplier Count',
	uniquE_SUPPLIER_COUNT: 'Supplier Count',
	uniquE_SPEND: 'Spend',
	totaL_SPEND: 'Spend',
};

export const MODULE_TIME_FEILDS = ['createD_AT', 'updateD_AT'];
export const MDOULE_SPEND_FEILDS = ['Spend', 'Spend'];

const DATE_OPTIONS = {
	year: '2-digit',
	month: '2-digit',
	day: '2-digit',
	hour: '2-digit',
	minute: '2-digit',
};
export const getDateFormated = (type, date) => {
	const dateObj = new Date(date);
	const formatter = new Intl.DateTimeFormat(type, DATE_OPTIONS);
	const formattedDate = formatter.format(dateObj);
	return formattedDate;
};

export const summarizeCounts = data => {
	const countData = [
		{
			name: 'Category 1',
			data: data.category1,
			count: data.category1 !== null ? data.category1.length : 0,
		},
		{
			name: 'Category 2',
			data: data.category2,
			count: data.category2 !== null ? data.category2.length : 0,
		},
		{
			name: 'Category 3',
			data: data.category3,
			count: data.category3 !== null ? data.category3.length : 0,
		},
		{
			name: 'Commodity Code',
			data: data.commodityCode,
			count: data.commodityCode !== null ? data.commodityCode.length : 0,
		},
		{
			name: 'Commodity Family',
			data: data.commodityFamily,
			count: data.commodityFamily != null ? data.commodityFamily.length : 0,
		},
		{
			name: 'Origin Country',
			data: data.originCountry,
			count: data.originCountry != null ? data.originCountry.length : 0,
		},
	];

	const totalCount = countData.reduce(
		(accumulator, current) => accumulator + current.count,
		0
	);

	return { countData, count: totalCount };
};

export const KPI_COLORS = {
	'SKU Count 1': 'rgba(255, 0, 0, 0.1)',
	'Category 1 Count 1': 'rgba(0, 255, 0, 0.1)',
	'Category 2 Count 1': 'rgba(0, 0, 255, 0.1)',
	'Category 3 Count 1': 'rgba(111, 50, 168, 0.1)',
	'Row Count 1': 'rgba(168, 164, 50, 0.1)',
	'Created At 1': 'rgba(168, 164, 50, 0.1)',
	'Updated At 1': 'rgba(168, 164, 50, 0.1)',
	'Supplier Count 1': 'rgba(168, 50, 111, 0.1)',
	'Spend 1': 'rgba(245, 149, 66,0.1)',
};
export const checkAndFormat = data => {
	return data.filter(x => x !== null).map(x => {
		return { label: x, value: x };
	});
};

export const filterInitialOptions = {
	category_1: {
		options: [],
		selectedOption: [],
	},
	category_2: {
		options: [],
		selectedOption: [],
	},
	category_3: {
		options: [],
		selectedOption: [],
	},
	commodity_Code: {
		options: [],
		selectedOption: [],
	},
	commodity_Family: {
		options: [],
		selectedOption: [],
	},
	supplier_count: {
		options: [],
		selectedOption: [],
	},
	supplier: {
		options: [],
		selectedOption: [],
	},
	dateRange: {
		srcRange: '',
		stateRange: '',
	},
	sku: {
		options: [],
		selectedOption: [],
	},
};

export const getModuleInfoFormatting = (
	moduleData,
	currencySymbol,
	hideDecimals
) => {
	return moduleData.reduce((acc, item) => {
		if (item.title === undefined) {
			acc.push({
				title: item.title,
				value: item.value,
			});
		} else {
			const existingSupplier = acc.find(s => s.title === item.title);
			const value = MDOULE_SPEND_FEILDS.includes(item.title)
				? formatSpendWithDecimalAndSymbol(
						item.value,
						currencySymbol,
						hideDecimals,
						1
				  ).toUpperCase()
				: item.value.toLocaleString().toString();
			if (existingSupplier) {
				existingSupplier.value = existingSupplier.value + ' / ' + value;
			} else {
				acc.push({
					title: item.title,
					value: value,
				});
			}
		}

		return acc;
	}, []);
};

export const checkAndFormatSuppliers = data => {
	return data.filter(x => x !== null).map(x => {
		return {
			label: x.supplier + ' (' + spendFormatter(x.spend, false) + ') ',
			value: x.supplier,
		};
	});
};

export const Loader = () => (
	<ApLoaderDefault loaderText={() => <ApLoaderText />} />
);
